const metrics = [
  { value: '100%', label: 'Commitment to modern engineering standards and best practices' },
  { value: '24/7', label: 'System reliability focus with continuous improvement cycles' },
];

export default function OverviewSection() {
  return (
    <section className="w-full bg-background-100 py-24 md:py-32 px-6 md:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start gap-16 lg:gap-24">
          <div className="lg:w-1/2">
            <span className="text-foreground-500 text-sm font-semibold tracking-widest uppercase">
              About
            </span>
            <p className="text-foreground-800 text-xl md:text-2xl leading-relaxed mt-6 max-w-lg font-heading">
              We are a professional engineering team dedicated to crafting modern
              digital software solutions with precision, clarity, and a relentless
              focus on technical quality. Every system we build is designed for
              long-term maintainability and real-world performance on the iOS platform
              and its surrounding ecosystem.
            </p>
          </div>

          <div className="lg:w-1/2 grid grid-cols-2 gap-x-12 gap-y-16">
            {metrics.map((metric) => (
              <div key={metric.label}>
                <p className="text-foreground-900 text-5xl md:text-6xl font-bold font-heading tracking-tight">
                  {metric.value}
                </p>
                <p className="text-foreground-500 text-sm md:text-base mt-3 leading-relaxed max-w-[200px]">
                  {metric.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}